import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColumnDefinition } from 'app/dto';

export * as AdditionalInfoModel from './additional-info.model';

export interface Category {
    name: string,
    disabled?: boolean,
    expanded: boolean,
    fields: Field[],
    key?: string,
    valuePath?: string
    isArray?: boolean;
    dataPath?: string;
    noBinding?: boolean;
    notImplemented?: boolean;
    jsonPath?: string;
}

export interface Field {
    filter?: FormlyFieldConfig;
    valuePath?: string;
    name: string;
    key: string;
    selected: boolean;
    isStatic?: boolean;
    exportColumn?: ColumnDefinition;
    jsonPath?: string;
}